
import { ref } from 'vue-demi';
import NNQ from '@futuweb/tool-nn/dist/nnq';
import * as browser from '@futuweb/tool-browser';

/**
 * 获取 app 配置的涨跌色，一般用来作为外层容器的 classname 来控制涨跌色类型
 * @param {Boolean} followApp 是否跟随 app 配置涨跌色，false 时直接返回第二个参数
 * @param {String} defaultRateColor 默认涨跌色，客户端不支持的情况下返回默认值
 * @returns {String} 返回 'quotes-color-${type}'
 */
export const useRateClsByApp = (followApp, defaultRateColor) => {
    const rateColorCls = ref(`quotes-color-${defaultRateColor || 0}`);

    if (!followApp) {
        return rateColorCls;
    }

    // 客户端不支持的话，直接返回默认值，安卓和ios刚好同版本发布 12.43.8908开始支持
    if (!browser.isMobileNN() || !browser.laterThanClient({ isXYZFormat: true, ver: '12.43.8908' })) {
        return rateColorCls;
    }

    NNQ.initBridge({}, () => {
        window.NNWebViewJSBridge.callHandler('getUpDownType', {}, (res) => {
            try {
                const ret = JSON.parse(res); // result: 0 成功， -1失败
                if (ret && ret.result === 0) {
                    const rate = +(ret.data || 0);
                    rateColorCls.value = `quotes-color-${rate}`;
                    //data:涨跌色，0红涨绿跌，1绿涨红跌，2色盲色涨色（粉涨绿跌），3色盲色跌色（绿涨粉跌）
                }
            } catch (e) {
                console.error(e);
            }
        });
    });

    return rateColorCls;
};
